import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './portal.css';

const win: any = window;

const lang = document.documentElement.lang;
const rtl = lang === 'ar';

!!!win["lang"] && (win["lang"] = lang);

ReactDOM.render(
  <React.StrictMode>
    <App rtl={rtl}/>
  </React.StrictMode>,
  document.getElementById('root')
);